// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: a-Kq7ZTga5
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicFormEnterButton.module.css"; // plasmic-import: a-Kq7ZTga5/css

createPlasmicElementProxy;

export const PlasmicFormEnterButton__VariantProps = new Array("subscribed");

export const PlasmicFormEnterButton__ArgProps = new Array();

const $$ = {};

function PlasmicFormEnterButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "subscribed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.subscribed
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <PlasmicLink__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        { [sty.rootsubscribed]: hasVariant($state, "subscribed", "subscribed") }
      )}
      platform={"react"}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__on9JH,
          {
            [sty.textsubscribed__on9JHjAp7A]: hasVariant(
              $state,
              "subscribed",
              "subscribed"
            )
          }
        )}
      >
        {hasVariant($state, "subscribed", "subscribed")
          ? "Thank you :)"
          : "Chat with us"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__ekYsH,
          {
            [sty.textsubscribed__ekYsHjAp7A]: hasVariant(
              $state,
              "subscribed",
              "subscribed"
            )
          }
        )}
      >
        {"We'll be in touch."}
      </div>
    </PlasmicLink__>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFormEnterButton__ArgProps,
          internalVariantPropNames: PlasmicFormEnterButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFormEnterButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFormEnterButton";
  } else {
    func.displayName = `PlasmicFormEnterButton.${nodeName}`;
  }
  return func;
}

export const PlasmicFormEnterButton = Object.assign(
  // Top-level PlasmicFormEnterButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicFormEnterButton
    internalVariantProps: PlasmicFormEnterButton__VariantProps,
    internalArgProps: PlasmicFormEnterButton__ArgProps
  }
);

export default PlasmicFormEnterButton;
/* prettier-ignore-end */
